import { Typography } from "@mui/material";
import {
  useGridApiContext,
  useGridSelector,
  gridSortedRowEntriesSelector,
  GridToolbarContainer,
} from "@mui/x-data-grid";

export const PclToolbar = () => {
  const apiRef = useGridApiContext();
  const filteredRows = useGridSelector(apiRef, gridSortedRowEntriesSelector);

  return (
    <GridToolbarContainer
      sx={{
        padding: "1em",
      }}
    >
      <Typography variant="h6">
        Showing: {filteredRows.length || 0} Matches
      </Typography>
    </GridToolbarContainer>
  );
};
